module.exports = __webpack_public_path__ + "img/icon_location.4729ac81.svg";